module.exports = __webpack_public_path__ + "static/media/logo-yellow.04e0d68f.png";